import { render } from "./StoryBankHome.vue?vue&type=template&id=78ffb9ae&scoped=true"
import script from "./StoryBankHome.vue?vue&type=script&lang=js"
export * from "./StoryBankHome.vue?vue&type=script&lang=js"

import "./StoryBankHome.vue?vue&type=style&index=0&id=78ffb9ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ffb9ae"]])

export default __exports__